import { createUserinfoStore } from '@webitel/ui-sdk/modules/Userinfo';

export const useUserinfoStore = createUserinfoStore();
